const getAuthStatus = () => {
  if (typeof window === "undefined") return { status: "not_logged_in", uuid: "NA" };

  try {
    const userStr = localStorage.getItem("user");
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");

    if (userStr && accessToken && refreshToken) {
      const parsedUser = JSON.parse(userStr);
      let uuid = parsedUser?.userData?.id || parsedUser?.id || "NA";

      if (uuid !== "NA") {
        uuid = String(uuid).substring(0, 36);
      }

      return { status: "logged_in", uuid };
    }
  } catch (error) {
    console.error("Error reading auth from localStorage", error);
  }

  return { status: "not_logged_in", uuid: "NA" };
};

const convertTimestampToYYYYMMDDHHMM = (timestamp) => {
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return "NA";

  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, '0') + "-" +
    String(date.getDate()).padStart(2, '0') + " " +
    String(date.getHours()).padStart(2, '0') + ":" +
    String(date.getMinutes()).padStart(2, '0');
};

const getCommentCount = () => {
  if (typeof window !== "undefined") {
    const commentCountElement = document.querySelector(".coral-count");
    if (commentCountElement) {
      const text = commentCountElement.innerText.trim();
      const count = Number(text);
      return isNaN(count) ? "NA" : count;
    }
  }
  return "NA";
};

export const pushPageDataLayer = (pageType, userData = {}, pageData = {}) => {
  if (typeof window === "undefined") return;

  const auth = getAuthStatus();

  if (pageType === "not-found" || pageType === "404") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_type: "404",
      auth_status: auth.status,
      uuid: auth.uuid
    });
    return;
  }

  const dataLayerObject = {
    event: "page_view",
    page_type: "NA",
    author_name: "NA",
    section_name: "NA",
    published_date: "NA",
    last_updated_date: "NA",
    content_id: "NA",
    article_id: "NA",
    article_type: "NA",
    story_tags: "NA",
    story_words: "NA",
    comment_number: "NA",
    author_id: "NA",
    content_title: "NA",
    created_date: "NA",
    creator_name: "NA",
    auth_status: auth.status,
    uuid: auth.uuid,
  };

  if (pageType === "home-page" || pageType === "home") {
    dataLayerObject.page_type = "home_page";

  } else if (pageType === "story-page" || pageType === "article") {
    dataLayerObject.page_type = "article_page";

    if (pageData?.story) {
      const story = pageData.story;

      dataLayerObject.author_name = story["author-name"] || story.author || "NA";
      dataLayerObject.content_id = story.id || "NA";
      dataLayerObject.article_id = story["public-identifier"] || story["story-template"] || story.id || "NA";
      dataLayerObject.article_type = story["story-template"] || "NA";

      dataLayerObject.author_id = story.authors?.map(author => author.id).join(",") || "NA";
      dataLayerObject.content_title = story.headline || "NA";
      dataLayerObject.creator_name = story["owner-name"] || "NA";

      if (story["content-created-at"]) {
        dataLayerObject.created_date = convertTimestampToYYYYMMDDHHMM(story["content-created-at"]);
      }

      dataLayerObject.story_tags = story.tags ? story.tags.map(t => t.name).join(",") : "NA";

      dataLayerObject.story_words = story["word-count"] || "NA";

      if (story["first-published-at"] || story["published-at"]) {
        dataLayerObject.published_date = convertTimestampToYYYYMMDDHHMM(story["first-published-at"] || story["published-at"]);
      }

      if (story["last-published-at"]) {
        dataLayerObject.last_updated_date = convertTimestampToYYYYMMDDHHMM(story["last-published-at"]);
      }

      if (story.sections && story.sections.length > 0) {
        dataLayerObject.section_name = story.sections.map(s => s.name).join(",");
      }
    }

  } else if (pageType === "section-page") {
    if (pageData?.section) {
      const section = pageData.section;
      dataLayerObject.page_type = section["parent-id"] ? "sub_section_page" : "section_page";
      dataLayerObject.section_name = section["display-name"] || section.name || "NA";
    }
  } else if (pageType === "search") {
    dataLayerObject.page_type = "search_page";
  } else if (pageType === "author-page" || pageType === "author") {
    dataLayerObject.page_type = "author_page";
    if (pageData?.author) {
      dataLayerObject.author_name = pageData.author.name || "NA";
    }
  } else if (pageType === "tag-page" || pageType === "tag") {
    dataLayerObject.page_type = "tag_page";
  } else {
    dataLayerObject.page_type = pageType || "NA";
  }

  if (pageType === "story-page" || pageType === "article") {
    setTimeout(() => {
      dataLayerObject.comment_number = getCommentCount();
      // console.log('Data layer pushed with comment count:', dataLayerObject.comment_number);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerObject);
    }, 1500);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerObject);
  }
};

export const pushEventToDataLayer = (eventName) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName });
};

export const addSignUpLoginToDataLayer = (url, data) => {
  if (typeof window === "undefined") return;

  let eventType = "login";
  let loginSource = url || "NA";
  let authMethod = data?.method || "email";
  let consentStatus = data?.consent ? "granted" : "denied";

  if (data?.created_at) {
    const createdAtTime = new Date(data.created_at).getTime();
    const currentTime = new Date().getTime();

    if (currentTime - createdAtTime < 60000) {
      eventType = "signup";
    }
  }

  const auth = getAuthStatus();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventType,
    login_source: loginSource,
    authentication_method: authMethod,
    consent_status: consentStatus,
    uuid: auth.uuid,
    auth_status: "logged_in"
  });
};

export const addLogoutToDataLayer = () => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "logout",
    auth_status: "not_logged_in",
    uuid: "NA"
  });
};

export const addAuthTrackingToDataLayer = (status) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "auth_state_change", auth_status: status });
};

export const addClickTrackingToDataLayer = (url, text, id) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "widget_click",
    click_url: url || "NA",
    click_text: text || "NA",
    click_id: id || "NA"
  });
};
